import { css } from '@/styled-system/css';

export const comboboxGroupStyles = css.raw({});
